module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hd-footer"
  }, [_c('section', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "wrap",
    staticStyle: {
      "border-bottom": "1px dashed #fff",
      "padding-bottom": "20px",
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticStyle: {
      "width": "175px"
    },
    attrs: {
      "src": require("assets/images/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "infomation"
  }, [_c('p', [_vm._v("邮箱: "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("edubot@hitrobotgroup.com")])]), _vm._v(" "), _c('p', [_vm._v("客服电话: 0512-65001916")]), _vm._v(" "), _c('p', [_vm._v("联系地址: 中国（江苏）自由贸易试验区苏州片区苏州工业园区苏虹西路 99 号第 3 幢 B301 室")]), _vm._v(" "), _c('p', [_vm._v("关注我们:\n          "), _c('a', {
    attrs: {
      "href": "javascirpt:;"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20px",
      "vertical-align": "middle",
      "margin-left": "5px"
    },
    attrs: {
      "src": require("assets/images/icon_weibo.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/weixin.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("微信扫码 关注【江苏海渡】公众号")])])])]), _vm._v(" "), _c('footer', [_c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002001797",
      "target": "_blank"
    }
  }, [_vm._v("苏公网安备32059002001797号 ")]), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("苏ICP备16014610-5号")]), _vm._v(" ©江苏海渡教育科技集团有限公司 ©2022 All rights reserved\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a1203f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/hd-footer.vue
// module id = 371
// module chunks = 1